export default [
  {
    title: "All of Me",
    artist: "John Legend",
    slug: "4194910d",
    bpm: 126,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "all_of_me_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "all_of_me_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "all_of_me_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "all_of_me_vocals.mp3" },
      { id: "picking", volume: 1, filename: "all_of_me_picking.mp3" },
    ],
  },

  {
    title: "Afterglow",
    artist: "Ed Sheeran",
    slug: "3b9f2501",
    bpm: 110,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "afterglow_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "afterglow_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "afterglow_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "afterglow_vocals.mp3" },
    ],
  },

  {
    title: "Good Riddance (Time of Your Life)",
    artist: "Greenday",
    slug: "789704ab",
    bpm: 96,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "good_riddance_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "good_riddance_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "good_riddance_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "good_riddance_vocals.mp3" },
      { id: "picking", volume: 1, filename: "good_riddance_picking.mp3" },
    ],
  },

  {
    title: "Brown Eyed Girl",
    artist: "Van Morrison",
    slug: "946d33d7",
    bpm: 75,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "brown_eyed_girl_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "brown_eyed_girl_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "brown_eyed_girl_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "brown_eyed_girl_vocals.mp3" },
    ],
  },

  {
    title: "Perfect",
    artist: "Ed Sheeran",
    slug: "07857e5d",
    bpm: 93,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "perfect_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "perfect_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "perfect_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "perfect_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "perfect_vocals.mp3" },
    ],
  },

  {
    title: "Memories",
    artist: "Maroon 5",
    slug: "157c35ea",
    bpm: 91,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "memories_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "memories_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "memories_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "memories_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "memories_vocals.mp3" },
    ],
  },

  {
    title: "Can't Help Falling In Love",
    artist: "Elvis Presley",
    slug: "1817381e",
    bpm: 100,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "CHFIL_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "CHFIL_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "CHFIL_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "CHFIL_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "CHFIL_vocals.mp3" },
      { id: "drum", volume: 1, filename: "CHFIL_drums.mp3" },
    ],
  },

  {
    title: "Lewis Capaldi",
    artist: "Someone You Loved",
    slug: "b0af969d",
    bpm: 110,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "someone_you_loved_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "someone_you_loved_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "someone_you_loved_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "someone_you_loved_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "someone_you_loved_vocals.mp3" },
    ],
  },

  {
    title: "Blinding Lights",
    artist: "The Weeknd",
    slug: "ed4ef7f6",
    bpm: 171,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "blinding_lights_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "blinding_lights_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "blinding_lights_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "blinding_lights_vocals.mp3" },
      { id: "drum", volume: 1, filename: "blinding_lights_drums.mp3" },
    ],
  },

  {
    title: "Forever & Always (Taylor's Version)",
    artist: "Taylor Swift",
    slug: "b286c50a",
    bpm: 128,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "forever_and_always_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "forever_and_always_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "forever_and_always_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "forever_and_always_vocals.mp3" },
      { id: "drum", volume: 1, filename: "forever_and_always_drum.mp3" },
    ],
  },

  {
    title: "Wonderwall",
    artist: "Oasis",
    slug: "44aacaa9",
    bpm: 88,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "wonderwall_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "wonderwall_metronome.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "wonderwall_drums.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "wonderwall_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "wonderwall_vocals.mp3" },
      {
        id: "extra",
        volume: 1,
        filename: "wonderwall_filler.mp3",
        label: "Cello & Piano",
      },
    ],
  },

  {
    title: "Yellow",
    artist: "Coldplay",
    slug: "05a622e3",
    bpm: 86,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "yellow_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "yellow_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "yellow_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "yellow_vocals.mp3" },
      { id: "drum", volume: 1, filename: "yellow_drums.mp3" },
    ],
  },

  {
    title: "deja vu",
    artist: "Olivia Rodrigo",
    slug: "40e4f237",
    bpm: 91,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "dejavu_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "dejavu_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "dejavu_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "dejavu_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "dejavu_vocals.mp3" },
      { id: "drum", volume: 1, filename: "dejavu_drums.mp3" },
      { id: "extra", volume: 1, filename: "dejavu_extras.mp3" },
    ],
  },
  {
    title: "Yesterday",
    artist: "The Beatles",
    slug: "09ad66be",
    bpm: 96,
    channels: [
      {
        id: "metronome",
        volume: 1,
        filename: "yesterday_metronome.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "yesterday_strumming_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "yesterday_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "yesterday_vocals.mp3" },
      { id: "extra", volume: 1, filename: "yesterday_strings.mp3" },
    ],
  },
  {
    title: "Amazing Grace",
    artist: "",
    slug: "bfbeac85",
    bpm: 75,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "amazinggrace_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "amazinggrace_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "amazinggrace_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "amazinggrace_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "amazinggrace_vocals.mp3" },
    ],
  },

  {
    title: "I'm Yours",
    artist: "Jason Mraz",
    slug: "723d95dc",
    bpm: 150,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "im_yours_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "im_yours_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "im_yours_solo.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "im_yours_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "im_yours_vocals.mp3" },
      { id: "drum", volume: 1, filename: "im_yours_drums.mp3" },
      { id: "extra", volume: 1, filename: "im_yours_extra.mp3" },
    ],
  },

  {
    title: "Shivers",
    artist: "Ed Sheeran",
    slug: "a2710024",
    bpm: 141,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "shivers_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "shivers_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "shivers_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "shivers_vocals.mp3" },
      { id: "drum", volume: 1, filename: "shivers_drums.mp3" },
      { id: "extra", volume: 1, filename: "shivers_extras.mp3" },
    ],
  },

  {
    title: "Riptide",
    artist: "Vance Joy",
    slug: "2a91e1eb",
    bpm: 102,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "riptide_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "riptide_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "riptide_solo.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "riptide_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "riptide_vocals.mp3" },
      { id: "drum", volume: 1, filename: "riptide_drums.mp3" },
    ],
  },

  {
    title: "death bed (coffee for your head)",
    artist: "Powfu",
    slug: "e91d26f5",
    bpm: 144,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "deathbed_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "deathbed_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "deathbed_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "deathbed_vocals.mp3" },
      { id: "drum", volume: 1, filename: "deathbed_drums.mp3" },
      { id: "extra", volume: 1, filename: "deathbed_rap_extras.mp3" },
    ],
  },

  {
    title: "With or Without You",
    artist: "U2",
    slug: "ed543a32",
    bpm: 110,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "with_or_without_you_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "with_or_without_you_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "with_or_without_you_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "with_or_without_you_vocals.mp3" },
      { id: "drum", volume: 1, filename: "with_or_without_you_drums.mp3" },
      { id: "extra", volume: 1, filename: "with_or_without_you_extra.mp3" },
    ],
  },

  {
    title: "Before You Go",
    artist: "Lewis Capaldi",
    slug: "71e6f661",
    bpm: 112,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "before_you_go_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "before_you_go_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "before_you_go_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "before_you_go_practice_strum.mp3",
      },
      { id: "vocal", volume: 1, filename: "before_you_go_vocals.mp3" },
      { id: "drum", volume: 1, filename: "before_you_go_drums.mp3" },
      { id: "extra", volume: 1, filename: "before_you_go_extra.mp3" },
    ],
  },

  {
    title: "Wildest Dreams",
    artist: "Taylor Swift",
    slug: "ccf96151",
    bpm: 140,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "wildest_dreams_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "wildest_dreams_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "wildest_dreams_practice_strum.mp3",
      },
      { id: "vocal", volume: 1, filename: "wildest_dreams_vocals.mp3" },
      { id: "drum", volume: 1, filename: "wildest_dreams_drums.mp3" },
      { id: "extra", volume: 1, filename: "wildest_dreams_extra.mp3" },
    ],
  },

  {
    title: "A Thousand Years",
    artist: "Christina Perri",
    slug: "53b7630c",
    bpm: 139,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "a_thousand_years_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "a_thousand_years_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "a_thousand_years_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "a_thousand_years_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "a_thousand_years_vocals.mp3" },
      { id: "drum", volume: 1, filename: "a_thousand_years_drums.mp3" },
      { id: "extra", volume: 1, filename: "a_thousand_years_extra.mp3" },
    ],
  },

  {
    title: "Bad Habits",
    artist: "Ed Sheeran",
    slug: "f30ee700",
    bpm: 126,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "bad_habits_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "bad_habits_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "bad_habits_solo_tab.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "bad_habits_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "bad_habits_vocals.mp3" },
      { id: "extra", volume: 1, filename: "bad_habits_beats.mp3" },
    ],
  },

  {
    title: "All Too Well",
    artist: "Taylor Swift",
    slug: "90f13138",
    bpm: 93,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "all_too_well_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "all_too_well_metronome.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "all_too_well_solo.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "all_too_well_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "all_too_well_vocals.mp3" },
      { id: "drum", volume: 1, filename: "all_too_well_drums.mp3" },
    ],
  },

  {
    title: "Hey There Delilah",
    artist: "Plain White T's",
    slug: "2482e659",
    bpm: 104,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "hey_there_delilah_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "hey_there_delilah_metronome_104.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "hey_there_delilah_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "hey_there_delilah_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "hey_there_delilah_vocals.mp3" },
    ],
  },

  {
    title: "Heat Waves",
    artist: "Glass Animals",
    slug: "e915d255",
    bpm: 81,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "heat_waves_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "heat_waves_metronome_81.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "heat_waves_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "heat_waves_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "heat_waves_vocals.mp3" },
      { id: "drum", volume: 1, filename: "heat_waves_drums.mp3" },
      { id: "extra", volume: 1, filename: "heat_waves_extra.mp3" },
    ],
  },

  {
    title: "Take It Easy",
    artist: "Eagles",
    slug: "f6c7cef3",
    bpm: 139,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "take_it_easy_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "take_it_easy_metronome_139.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "take_it_easy_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "take_it_easy_vocals.mp3" },
      { id: "drum", volume: 1, filename: "take_it_easy_drums.mp3" },
      { id: "extra", volume: 1, filename: "take_it_easy_extra.mp3" },
    ],
  },

  {
    title: "Hey, Soul Sister",
    artist: "Train",
    slug: "efc4276a",
    bpm: 194,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "hey_soul_sister_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "hey_soul_sister_metronome_194.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "hey_soul_sister_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "hey_soul_sister_vocals.mp3" },
      { id: "drum", volume: 1, filename: "hey_soul_sister_drums.mp3" },
      { id: "extra", volume: 1, filename: "hey_soul_sister_extra.mp3" },
    ],
  },

  {
    title: "Test",
    artist: "Test",
    slug: "test",
    bpm: 194,
    channels: [
      {
        id: "metronome",
        volume: 1,
        filename: "all_of_me_metronome.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "all_of_me_metronome.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "all_of_me_metronome.mp3",
      },
    ],
  },

  {
    title: "The Joker And The Queen",
    artist: "Ed Sheeran (ft. Taylor Swift)",
    slug: "ab25e0cd",
    bpm: 134,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "joker_and_the_queen_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "joker_and_the_queen_metronome_134.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "joker_and_the_queen_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "joker_and_the_queen_practice.mp3",
      },
      { id: "vocal", volume: 1, filename: "joker_and_the_queen_vocals.mp3" },
      { id: "extra", volume: 1, filename: "joker_and_the_queen_extra.mp3" },
    ],
  },

  {
    title: "California Dreamin'",
    artist: "The Mamas & the Papas",
    slug: "69fd49b5",
    bpm: 112,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "california_dreamin_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "california_dreamin_metronome_112.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "california_dreamin_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "california_dreamin_practice.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "california_dreamin_vocals.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "california_dreamin_drums.mp3",
      },
      {
        id: "extra",
        volume: 1,
        filename: "california_dreamin_extra.mp3",
      },
    ],
  },

  {
    title: "Chasing Cars",
    artist: "Snow Patrol",
    slug: "2dc8211f",
    bpm: 104,
    channels: [
      {
        id: "strum",
        volume: 1,
        filename: "chasing_cars_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "chasing_cars_metronome_104.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "chasing_cars_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "chasing_cars_practice.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "chasing_cars_vocals.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "chasing_cars_drums.mp3",
      },
      {
        id: "extra",
        volume: 1,
        filename: "chasing_cars_extra.mp3",
      },
    ],
  },

  {
    title: "Breathe",
    artist: "Taylor Swift",
    slug: "e4643001",
    bpm: 74,
    channels: [
      {
        id: "extra",
        volume: 1,
        filename: "breathe_extras.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "breathe_drums.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "breathe_vocals.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "breathe_strumming.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "breathe_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "breathe_metronome_74.mp3",
      },
    ],
  },

  {
    title: "The Middle",
    artist: "Jimmy Eat World",
    slug: "828799ac",
    bpm: 162,
    channels: [
      {
        id: "extra",
        volume: 1,
        filename: "the_middle_extra.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "the_middle_drums.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "the_middle_vocals.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "the_middle_strumming.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "the_middle_practice_strum.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "the_middle_metronome_162.mp3",
      },
    ],
  },
  {
    title: "Zombie",
    artist: "The Cranberries",
    slug: "2ab4c412",
    bpm: 84,
    channels: [
      {
        id: "extra",
        volume: 1,
        filename: "zombie_extra.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "zombie_drums.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "zombie_vocals.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "zombie_strumming.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "zombie_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "zombie_metronome_84.mp3",
      },
    ],
  },
  {
    title: "Island in the Sun",
    artist: "Weezer",
    slug: "fb06ee0d",
    bpm: 115,
    channels: [
      {
        id: "drum",
        volume: 1,
        filename: "island_in_the_sun_drums.mp3",
      },
      {
        id: "extra",
        volume: 1,
        filename: "island_in_the_sun_extras.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "island_in_the_sun_vocals.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "island_in_the_sun_strumming.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "island_in_the_sun_strumming.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "island_in_the_sun_metronome_115.mp3",
      },
    ],
  },
  {
    title: "Every Rose Has Its Thorn",
    artist: "Poison",
    slug: "e3a1de43",
    bpm: 140,
    channels: [
      {
        id: "drum",
        volume: 1,
        filename: "every_rose_drums.mp3",
      },
      {
        id: "extra",
        volume: 1,
        filename: "every_rose_extra.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "every_rose_vocals.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "every_rose_strumming.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "every_rose_practice.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "every_rose_metronome_140.mp3",
      },
    ],
  },
  {
    title: "Photograph",
    artist: "Ed Sheeran",
    slug: "eef9cbc8",
    bpm: 108,
    channels: [
      {
        id: "extra",
        volume: 1,
        filename: "photograph_extra.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "photograph_drums.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "photograph_vocals.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "photograph_picking.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "photograph_strumming.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "photograph_practice.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "photograph_metronome_108.mp3",
      },
    ],
  },
  {
    title: "Every Breath You Take",
    artist: "The Police",
    slug: "f6020f7c",
    bpm: 117,
    channels: [
      {
        id: "extra",
        volume: 1,
        filename: "every_breath_extra.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "every_breath_drums.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "every_breath_vocals.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "every_breath_picking.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "every_breath_strumming.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "every_breath_practice.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "every_breath_metronome_117.mp3",
      },
    ],
  },

  {
    title: "Anti-Hero",
    artist: "Taylor Swift",
    slug: "b9e9b733",
    bpm: 97,
    channels: [
      {
        id: "extra",
        volume: 1,
        filename: "anti-hero_extra.mp3",
      },
      {
        id: "drum",
        volume: 1,
        filename: "anti-hero_drums.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "anti-hero_vocals.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "anti-hero_strumming.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "anti-hero_practice_strum.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "anti-hero_metronome_97.mp3",
      },
    ],
  },

  {
    title: "Believer",
    artist: "Imagine Dragons",
    slug: "623dfb56",
    bpm: 125,
    channels: [
      {
        id: "drum",
        volume: 1,
        filename: "believer_drums.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "believer_metronome_125.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "believer_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "believer_practice.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "believer_strumming.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "believer_vocals.mp3",
      },
    ],
  },
  {
    title: "Stand By Me",
    artist: "Ben E. King",
    slug: "0f2a9a2e",
    bpm: 118,
    channels: [
      {
        id: "drum",
        volume: 1,
        filename: "stand_by_me_drums.mp3",
      },
      {
        id: "extra",
        volume: 1,
        filename: "stand_by_me_extras.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "stand_by_me_metronome_118.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "stand_by_me_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "stand_by_me_practice.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "stand_by_me_strumming.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "stnad_by_me_vocals.mp3",
      },
    ],
  },
  {
    title: "Let it be",
    artist: "The Beatles",
    slug: "e99d0fc5",
    bpm: 72,
    channels: [
      {
        id: "drum",
        volume: 1,
        filename: "let_it_be_drums.mp3",
      },
      {
        id: "metronome",
        volume: 1,
        filename: "let_it_be_metronome_72bpm.mp3",
      },
      {
        id: "picking",
        volume: 1,
        filename: "let_it_be_picking.mp3",
      },
      {
        id: "practice",
        volume: 1,
        filename: "let_it_be_practice_strum.mp3",
      },
      {
        id: "strum",
        volume: 1,
        filename: "let_it_be_strumming.mp3",
      },
      {
        id: "vocal",
        volume: 1,
        filename: "let_it_be_vocals.mp3",
      },
    ],
  },
];
